module.exports = {
  api: {
    base_api: "https://api.jzuseful.cn/v1/",
    // base_api: "https://api.zulu.wang/v1/",
    redirect_uri: "https://shcy-wsxy.jzuseful.cn",
    // redirect_uri: "https://next.zulu.wang",
  },
};
